module.exports = __webpack_public_path__ + "assets/img/caixiaBank.1f3de212.png";